export const AUTHENTICATION_INFO_STORAGE_KEY = 'authentication_info';
export const TWO_FACTOR_AUTH_INFO_STORAGE_KEY = '2fa_info';
